import {createModel} from "@rematch/core";
import {RootModel} from "./index";
import request from "../util/request";

export const activitySign: any = createModel<RootModel>()({
  state: {
    info: {},
    request: {
      activityId: "",
      start: "",
      end: "",
      pageSize: 20,
      pageNum: 1,
      keyword: "",
    },
    data: {
      total: 0,
      pageNum: 1,
      pageSize: 20,
      list: [],
    },
  }, // initial state
  reducers: {
    // handle state changes with pure functions
    /**
     * 设置值
     *
     * @param state
     * @param payload
     */
    setData(state, payload) {
      return {...state, ...payload}
    }
  },
  effects: (dispatch) => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    /**
     * 分页获取活动报名列表
     */
    async page(payload, rootState) {
      let res = await request.post("/host-admin/v1/activitySign/page", rootState.activitySign.request)
      if (res.code === 0) {
        res.data.list.forEach((item: any) => {
          item.key = item.id
        })
        dispatch.activitySign.setData({data: res.data})
      }
      return res
    },

    /**
     * 获取报名详情
     *
     * @param id
     * @param rootState
     */
    async getInfo(id, rootState) {
      let res = await request.get(`/host-admin/v1/activitySign/info/${id}`)
      if (res.code === 0) {
        dispatch.activitySign.setData({info: res.data})
      }
      return res
    },

    /**
     * 删除报名记录
     *
     * @param id
     * @param rootState
     */
    async delete(id, rootState) {
      let res = await request.delete(`/host-admin/v1/activitySign/${id}`)
      return res
    },

    /**
     * 下载活动报名数据
     *
     * @param payload
     * @param rootState
     */
    async download(payload, rootState) {
      await request.download("/host-admin/v1/activitySign/download", rootState.activitySign.request, "activitySign.xlsx")
    },

  }),
})